import ReactDOM from 'react-dom';
import React from 'react';
import { IQuote } from './interfaces';
import OnlineMasteringQuotesGallery from './quotes-gallery';

export const initOnlineMasteringQuotesGallery = () => {

    const $placeholder = document.getElementById('olm-quotes-gallery');
    if(!$placeholder) {
        console.error('Element with id="olm-quotes-gallery" is missing.');
        return;
    }

    const $data = document.getElementById('quotes-json');
    if(!$data) {
        console.error('Element with id="quotes-json" is missing.');
        return;
    }

    let quotes: IQuote[] = [];

    try {
        quotes = JSON.parse($data?.textContent ?? '');
    }
    catch (ex) {
        console.error('Parse data error', ex);
        return;
    }

    if(!quotes?.length) {
        console.error('No quotes found.');
        return;
    }

    ReactDOM.render(
        <React.StrictMode>
            <OnlineMasteringQuotesGallery
                quotes={ quotes }
            />
        </React.StrictMode>,
        $placeholder,
    );
};